import { render, staticRenderFns } from "./ReviseRole.vue?vue&type=template&id=71633fb7&"
import script from "./ReviseRole.vue?vue&type=script&lang=js&"
export * from "./ReviseRole.vue?vue&type=script&lang=js&"
import style0 from "./ReviseRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports